export default "__VITE_ASSET__BORgIkej__"